import { ArrowCircleDown, ArrowDownward, ArrowUpward, Close, CloseRounded, Cloud, ContentCopy, ContentCut, ContentPaste, Hive, Inbox, Mail, MoreHoriz, Search } from '@mui/icons-material';
import { Avatar, Box, Button, Chip, Container, Divider, Drawer, Grid, IconButton, List, ListItem, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText, MenuItem, MenuList, SwipeableDrawer, TextField, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import React, { Component } from 'react';
import "./MessengerMobile.css";
import ContactLeadsReportRegular from '../../ContactLeadsReport/ContactLeadsReportRegular';
import { deepPurple } from '@mui/material/colors';
import ConversationSearch from '../../ConversationSearch';
import DrawerMobile from './DrawerMobile';
import MainMenu from './MainMenu';
import Global from "../../../customlib/Global";
import Handover from '../../Handover';
import moment from 'moment';
import MonitoringPerpindahanContact from '../../Monitoring/PerpindahanContact';
import DailyClosingRateReport from '../../ContactLeadsReport/DailyClosingRateReport';
import InboxDibacaBelumRespon from '../../InboxDibacaBelumRespon';
import ContactLeadsReportHourly from '../../ContactLeadsReport/ContactLeadsReportHourly';
import BySalesByLabelByCategoryByCity from '../../ContactLeadsReport/BySalesByLabelByCategoryByCity';
import BySalesByLabelByCategory from '../../ContactLeadsReport/BySalesByLabelByCategory';
import KategoriIklanMobile from '../../ReportMobile/LeadsReportSummary/KategoriIklanMobile';
import ByCitiByCategory from '../../ContactLeadsReport/ByCityByCategory';
import ByCityByCustomerByCategoryByUrl from '../../ContactLeadsReport/ByCityByCustomerByCategoryByUrl';
import ByURL from '../../ContactLeadsReport/ByURL';
import SoldProductCategories from '../../ContactLeadsReport/SoldProductCategory';
import LeadsByWilayah from '../../ContactLeadsReport/LeadsByWilayah';
import CheckpointReportMobile from '../../ReportMobile/Checkpoint/CheckpointReportMobile';
import CheckPointReport from '../../ContactLeadsReport/CheckPointReport';
import HistoryPerubahanLabel from '../../ContactLeadsReport/HistoryPerubahanLabel';
import InboundByreferral from '../../ContactLeadsReport/InboundByReferral';
import LeadsMonitoring from '../../ContactLeadsReport/LeadsMonitoring';
import FollowUpHarian from '../../DataPending/FollowUpHarian';
import FollowupRutinWrapper from '../../DataPending/FollowupRutinWrapper';
import SalesResponseTimeReportFirstTime from '../../SalesResponseTimeReport/SalesResponseTimeReportFirstTime';
import SalesResponseTimeReportAverage from '../../SalesResponseTimeReport/SalesResponseTimeReportAverage';
import CsResponseTimeReportAverage from '../../SalesResponseTimeReport/CsResponseTimeReportAverage';
import TeleFuReport from '../../ContactLeadsReport/TeleFuReport';
import TeleChatByCustomer from '../../ContactLeadsReport/TeleChatByCustomer';
import EventReminderReportMobile from '../../DashboardTele/DashboardTeleMobile/EventReminderReportMobile';
import EventReminderReport from '../../ContactLeadsReport/EventReminderReport';
import TeleResponseTimeReportAverage from '../../SalesResponseTimeReport/TeleResponseTimeReportAverage';
import TeleDiChatOlehCustomerResponseTimeReportFirstTime from '../../SalesResponseTimeReport/TeleDiChatOlehCustomerResponseTimeReportFirstTime';
import TeleDiChatCustomerResponseTimeReportAverage from '../../SalesResponseTimeReport/TeleDiChatCustomerResponseTimeReportAverage';
import TeleFuEffectivityRate from '../../SalesResponseTimeReport/TeleFuEffectivityRate';
import TeleFuHsmMarketingEffectivityRate from '../../SalesResponseTimeReport/TeleFuHsmMarketingEffectivityRate';
import HsmTeleEffectivityRate from '../../SalesResponseTimeReport/HsmTeleEffectivityRate';
import DetailKedisiplinanFuTele from '../../KedisiplinanFuTele/DetailKedisiplinanFuTele';
import ResumeKedisiplinanFuTele from '../../KedisiplinanFuTele/ResumeKedisiplinanFuTele';
import CustomerServiceHelp from '../../CustomerServiceHelp';
import ContactsDashboard from '../../ContactsDashboard';
import DataPendingLeads from '../../DataPending/DataPendingLeads';
import DataPendingLeadsParcel from '../../DataPending/DataPendingLeadsParcel';
import LeadsBelumadaLabel from '../../DataPending/LeadsbelumAdaLabel';
import AnalisaDataCancel from '../../DataPending/AnalisaDataCancel';
import DashboardPerformaSales from '../../DashboardPerformaSales';
import FollowUpReport from '../../DataPending/FollowUpReport';
import DataPendingEffectivityRate from '../../DataPending/DataPendingEffectivityRate';
import DataPendingLeadsParcelMobile from '../../DataPending/DataPendingMobile/DataPendingLeadsParcelMobile';
import LeadsParcel from '../../DataPending/LeadsParcel';
class MessengerMobile extends Component {

    state = {
        showSearch: false,
        searchInMessages: false,
        searchInField: "fromName",
        left: false,
        drawerMode: Global.DRAWER_MODE_MENUS
    }

    handleToggleShowSearch = () => {
        this.setState({ showSearch: !this.state.showSearch });
    }

    handleSelectSearchInField = (value) => {
        console.log("MOBILE", value);
        this.setState({ searchInField: value });
    }

    toggleDrawer = (anchor, open, resetView) => (event) => {
        // if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        // return;
        // }
        console.log("MOBILE_INI", "KLIKED");
        this.setState({ ...this.state, [anchor]: open, drawerMode: resetView ? Global.DRAWER_MODE_MENUS : this.state.drawerMode });
        // this.setState({left: true});
    };

    handleMenuSelected = (drawerMode) => {

        if ([Global.DRAWER_MODE_CUSTOMER_SERVICE_HELP].includes(drawerMode)) {
            this.setState({ ...this.state, ["left"]: false, drawerMode: drawerMode });
        } else {
            this.setState({ drawerMode: drawerMode });
        }

    }

    render() {

        if (this.state.drawerMode === Global.DRAWER_MODE_CUSTOMER_SERVICE_HELP) {
            return (
                <CustomerServiceHelp {...this.props} onCloseCsHelp={() => this.setState({ ...this.state, ["left"]: false, drawerMode: Global.DRAWER_MODE_MENUS })} />
            );
        }

        return (
            <Container fixed className="main-bg corner-background-top">
                <Grid container spacing={1}>
                    <Grid item xs={4} sm={4}>
                        <Box onClick={this.toggleDrawer("left", true, false)}>
                            <Typography variant="h6" gutterBottom component="div" sx={{ p: 2, pb: 0, color: "white" }}>
                                Menu
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={8} sm={8} textAlign={"right"}>
                        <Typography variant="h5" gutterBottom component="div" sx={{ p: 2, pb: 0 }}>
                            Messages &amp; Chat
                        </Typography>
                        <Divider sx={{ mt: 3 }} />
                        <Box>
                            {/* <Button onClick={() => this.props.setSortConversationMethod("LABEL")} size='small' variant='text' sx={{textTransform: 'capitalize'}} color='inherit'>
                                Sort by <ArrowDownward sx={{width: "13px", ml: "5px"}} />
                            </Button>
                            <ToggleButtonGroup color='primary' value={this.props.sortConversationBy} size="small" exclusive onChange={(event, newValue) => {this.props.setSortConversationMethod(newValue);console.log("SORTCEK",newValue);}} aria-label="Small sizes">
                                <ToggleButton value="LABEL" key="left">
                                    Label
                                </ToggleButton>,
                                <ToggleButton value="TIME" key="center">
                                    Time                                    
                                </ToggleButton>
                            </ToggleButtonGroup>
                            <ToggleButtonGroup color='primary' value={this.props.sortConversationType} size="small" exclusive onChange={(event, newValue) => {this.props.setSortType(newValue);console.log("SORTCEK",newValue);}} aria-label="Small sizes">
                                <ToggleButton value="DESC" key="left">
                                    <ArrowUpward />
                                </ToggleButton>,
                                <ToggleButton value="ASC" key="center">
                                    <ArrowDownward />                                    
                                </ToggleButton>
                            </ToggleButtonGroup> */}
                        </Box>
                        {/* <Box>
                            <Button onClick={() => this.props.setSortConversationMethod("TIME")} size='small' variant='text' sx={{textTransform: 'capitalize'}} color='inherit'>
                                Sort by time <ArrowUpward sx={{width: "13px", ml: "5px"}} />
                            </Button>
                        </Box> */}
                    </Grid>
                </Grid>




                <Grid container spacing={1} sx={{ mt: "7px" }}>
                    <Grid xs={5} sx={{ textAlign: "right", mt: "5px" }}>
                        <strong>Sort</strong>
                    </Grid>
                    <Grid xs={4} sx={{ textAlign: "right" }}>
                        <ToggleButtonGroup color='primary' value={this.props.sortConversationBy} size="small" exclusive onChange={(event, newValue) => { this.props.setSortConversationMethod(newValue); console.log("SORTCEK", newValue); }} aria-label="Small sizes">
                            <ToggleButton value="LABEL" key="sort-label">
                                Label
                            </ToggleButton>,
                            <ToggleButton value="TIME" key="sort-time">
                                Time
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Grid>
                    <Grid xs={3} sx={{ textAlign: "right" }}>
                        <ToggleButtonGroup color='primary' value={this.props.sortConversationType} size="small" exclusive onChange={(event, newValue) => { this.props.setSortType(newValue); console.log("SORTCEK", newValue); }} aria-label="Small sizes">
                            <ToggleButton value="ASC" key="sort-desc">
                                <ArrowUpward />
                            </ToggleButton>,
                            <ToggleButton value="DESC" key="sort-asc">
                                <ArrowDownward />
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Grid>
                    {/* <Button onClick={() => this.props.setSortConversationMethod("LABEL")} size='small' variant='text' sx={{textTransform: 'capitalize'}} color='inherit'>
                            Sort by <ArrowDownward sx={{width: "13px", ml: "5px"}} />
                        </Button> */}



                </Grid>
                {/* Search Chat */}
                <Box>
                    {
                        this.state.showSearch && (
                            <Box sx={{ pb: "5px", pt: "5px" }}>
                                <Box>
                                    <Grid container>
                                        <Grid item xs={11}>
                                            <TextField
                                                fullWidth
                                                label="Search by chat"
                                                variant="outlined"
                                                size='small'
                                                placeholder='Nama / Nomor'
                                                sx={{ backgroundColor: "#FFFFFF" }}
                                            />
                                        </Grid>
                                        <Grid item xs={1}>
                                            <IconButton size='small' color='error' onClick={this.handleToggleShowSearch}>
                                                <CloseRounded />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <Box sx={{ mt: "5px" }}>
                                    <Chip label={"Nama"} color={this.state.searchInField === "fromName" ? "primary" : "default"} size='small' onClick={(event) => this.handleSelectSearchInField("fromName")} />&nbsp;
                                    <Chip label={"Nomor"} color={this.state.searchInField === "from" ? "primary" : "default"} size='small' onClick={(event) => this.handleSelectSearchInField("from")} />&nbsp;
                                    <Chip label={"Sales"} color={this.state.searchInField === "assignToUserName" ? "primary" : "default"} size='small' onClick={(event) => this.handleSelectSearchInField("assignToUserName")} />
                                </Box>
                            </Box>
                        )
                    }
                    {
                        !this.state.showSearch && (
                            <Button
                                // onClick={this.handleToggleShowSearch} 
                                // onClick={this.setState({drawerMode: Global.DRAWER_MODE_CONVERSATION_SEARCH})} 
                                onClick={() => {
                                    this.handleMenuSelected(Global.DRAWER_MODE_CONTACTS);
                                    this.toggleDrawer("left", true, false);
                                }}
                                size='small'
                                variant='text'
                                sx={{ textTransform: 'capitalize' }} color='inherit'
                            >
                                Search by chat <Search sx={{ width: "15px", ml: "5px" }} />
                            </Button>
                        )
                    }

                </Box>
                {/* Search Chat */}





                {/* Conversation List */}
                <Box>
                    <List>
                        {
                            this.props.conversationData.map(
                                conversation => (
                                    <ListItem key={`conv-item-${conversation.fromNumber}`}
                                        secondaryAction={
                                            <Box edge="end" aria-label="delete" sx={{ textAlign: "center" }}>
                                                {
                                                    (conversation.unreadCounter && conversation.unreadCounter > 0) ? (
                                                        <Box textAlign={"center"}>
                                                            <Chip label={conversation.unreadCounter} color="primary" size='small' />
                                                        </Box>
                                                    ) : <Box>&nbsp;</Box>
                                                }


                                                <Box textAlign={"center"} fontSize={"13px"}>
                                                    {/* {moment.unix(conversation.lastMessageTime).diff(moment.now(), "days") > 0 ? moment.unix(conversation.lastMessageTime).diff(moment.now(), "days") + " days" : moment.unix(conversation.lastMessageTime).tz("asia/jakarta").format("HH:mm:ss")} */}
                                                    {Global.timeAgoFromUnixTimeStamps(conversation.lastMessageTime)}
                                                </Box>
                                            </Box>
                                        }
                                        color='warning'
                                        sx={{ backgroundColor: "#FFFFFF98", mb: "8px" }}
                                        onClick={() => this.props.onSelect(conversation)}
                                    >
                                        <ListItemAvatar>
                                            <Avatar src='aaa.jpg' alt={conversation.fromName} sx={{ bgcolor: "#651fff" }}>

                                                {/* <ImageIcon /> */}
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText primary={<strong>{conversation.fromName}</strong>} secondary={conversation.text && conversation.text.length > 50 ? conversation.text.substr(0, 35) : conversation.text} />
                                    </ListItem>
                                )
                            )
                        }
                    </List>
                </Box>
                {/* Conversation List */}




                {/* Drawer Menu */}
                {/* {['left', 'right', 'top', 'bottom'].map((anchor) => ( */}
                {['left'].map((anchor) => (
                    <React.Fragment key={anchor}>
                        {/* <Button onClick={this.toggleDrawer(anchor, true)}>{anchor}</Button> */}
                        <SwipeableDrawer
                            anchor={anchor}
                            open={this.state[anchor]}
                            onClose={this.toggleDrawer(anchor, false)}
                            onOpen={this.toggleDrawer(anchor, true)}
                        >
                            <DrawerMobile>
                                {this.state.drawerMode === Global.DRAWER_MODE_MENUS && (
                                    <MainMenu
                                        onMenuSelected={this.handleMenuSelected}
                                        listJustRead={this.props.listJustRead}
                                        {...this.props}
                                    />
                                )}

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_CONTACTS && (
                                        <Box sx={{ width: "100vw" }}>
                                            <ContactsDashboard
                                                onSelect={this.props.onSelect}
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                            />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_CONVERSATION_SEARCH && (
                                        <Box sx={{ width: "100vw" }}>
                                            <ConversationSearch
                                                onSelect={this.props.onSelect}
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                            />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_HANDOVER && (
                                        <Box sx={{ width: "100vw" }}>
                                            <Handover isMobile={true} onClose={this.toggleDrawer(anchor, false, true)} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_RIWAYAT_PERPINDAHAN_CONTACT && (
                                        <Box sx={{ width: "100vw" }}>
                                            <MonitoringPerpindahanContact isMobile={true} onClose={this.toggleDrawer(anchor, false, true)} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_DAILY_CLOSING_RATE && (
                                        <Box sx={{ width: "100vw" }}>
                                            <DailyClosingRateReport isMobile={true} onClose={this.toggleDrawer(anchor, false, true)} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_INBOX_DIBACA_BELUM_RESPON && (
                                        <Box sx={{ width: "100vw" }}>
                                            <InboxDibacaBelumRespon
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect} />
                                        </Box>
                                    )
                                }

                                {
                                    [Global.DRAWER_MODE_LEADS_REPORT_REGULAR, Global.DRAWER_MODE_DATA_CROSS_LEADS, Global.DRAWER_MODE_DATA_REPORTING_PER_SALES].includes(this.state.drawerMode) && (
                                        <Box sx={{ width: "100vw" }}>
                                            <ContactLeadsReportRegular
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_LEADS_REPORT_BY_HOURS && (
                                        <Box sx={{ width: "100vw" }}>
                                            <ContactLeadsReportHourly
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_SUMMARY_BY_SALES_LABEL_KATEGORI_KOTA && (
                                        <Box sx={{ width: "100vw" }}>
                                            <BySalesByLabelByCategoryByCity
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_SUMMARY_OVERVIEW_LEADS && (
                                        <Box sx={{ width: "100vw" }}>
                                            <BySalesByLabelByCategory
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_SUMMARY_KATEGORI_IKLAN && (
                                        <Box sx={{ width: "100vw" }}>
                                            <ByCitiByCategory
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_SUMMARY_URL_IKLAN && (
                                        <Box sx={{ width: "100vw" }}>
                                            <ByCityByCustomerByCategoryByUrl
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_SUMMARY_JUMLAH_URL_IKLAN && (
                                        <Box sx={{ width: "100vw" }}>
                                            <ByURL
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_SUMMARY_SOLD_CATEGORIES && (
                                        <Box sx={{ width: "100vw" }}>
                                            <SoldProductCategories
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_SUMMARY_LEADS_BY_WILAYAH && (
                                        <Box sx={{ width: "100vw" }}>
                                            <LeadsByWilayah
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_CHECKPOINT_REPORT && (
                                        <Box sx={{ width: "100vw" }}>
                                            <CheckPointReport
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_RIWAYAT_LABEL && (
                                        <Box sx={{ width: "100vw" }}>
                                            <HistoryPerubahanLabel
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_BY_REFERRAL && (
                                        <Box sx={{ width: "100vw" }}>
                                            <InboundByreferral
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_LEADS_MONITORING && (
                                        <Box sx={{ width: "100vw" }}>
                                            <LeadsMonitoring
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_FOLLOWUP_HARIAN && (
                                        <Box sx={{ width: "100vw" }}>
                                            <FollowUpHarian
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_FOLLOWUP_RUTIN && (
                                        <Box sx={{ width: "100vw" }}>
                                            <FollowupRutinWrapper
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_REPORT_FOLLOWUP && (
                                        <Box sx={{ width: "100vw" }}>
                                            <FollowUpReport
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_EFFECTIVITY_RATE && (
                                        <Box sx={{ width: "100vw" }}>
                                            <DataPendingEffectivityRate
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_LEADS_PARCEL && (
                                        <Box sx={{ width: "100vw" }}>
                                            <LeadsParcel
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_KECEPATAN_RESPON_BY_FIRST_RESPON && (
                                        <Box sx={{ width: "100vw" }}>
                                            <SalesResponseTimeReportFirstTime
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_KECEPATAN_RESPON_AVERAGE && (
                                        <Box sx={{ width: "100vw" }}>
                                            <SalesResponseTimeReportAverage
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_KECEPATAN_RESPON_CS_AVERAGE && (
                                        <Box sx={{ width: "100vw" }}>
                                            <CsResponseTimeReportAverage
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_DASHBOARD_TELE_FU_REPORT && (
                                        <Box sx={{ width: "100vw" }}>
                                            <TeleFuReport
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_DASHBOARD_TELE_DICHAT_CUSTOMER && (
                                        <Box sx={{ width: "100vw" }}>
                                            <TeleChatByCustomer
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_DASHBOARD_TELE_ER_REPORT && (
                                        <Box sx={{ width: "100vw" }}>
                                            <EventReminderReport
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_DASHBOARD_TELE_AVERAGE && (
                                        <Box sx={{ width: "100vw" }}>
                                            <TeleResponseTimeReportAverage
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_DASHBOARD_TELE_FIRST_RESPON_DICHAT_CUSTOMER && (
                                        <Box sx={{ width: "100vw" }}>
                                            <TeleDiChatOlehCustomerResponseTimeReportFirstTime
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_DASHBOARD_TELE_AVERAGE_DICHAT_CUSTOMER && (
                                        <Box sx={{ width: "100vw" }}>
                                            <TeleDiChatCustomerResponseTimeReportAverage
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_DASHBOARD_TELE_EFEKTIFITAS_FU && (
                                        <Box sx={{ width: "100vw" }}>
                                            <TeleFuEffectivityRate
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_DASHBOARD_TELE_EFEKTIFITAS_FU_HSM_MARKETING && (
                                        <Box sx={{ width: "100vw" }}>
                                            <TeleFuHsmMarketingEffectivityRate
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_DASHBOARD_TELE_EFEKTIFITAS_HSM && (
                                        <Box sx={{ width: "100vw" }}>
                                            <HsmTeleEffectivityRate
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_DASHBOARD_TELE_KEDISIPLINAN_FU && (
                                        <Box sx={{ width: "100vw" }}>
                                            <DetailKedisiplinanFuTele
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_DASHBOARD_TELE_RESUME_KEDISIPLINAN_FU && (
                                        <Box sx={{ width: "100vw" }}>
                                            <ResumeKedisiplinanFuTele
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_DATA_PENDING_LEADS && (
                                        <Box sx={{ width: "100vw" }}>
                                            <DataPendingLeads
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_DATA_PENDING_LEADS_PARCEL_EVENT && (
                                        <Box sx={{ width: "100vw" }}>
                                            <DataPendingLeadsParcel
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_DATA_PENDING_LEADS_BELUM_ADA_LABEL && (
                                        <Box sx={{ width: "100vw" }}>
                                            <LeadsBelumadaLabel
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_DASHBOARD_SOLUSI_DATA_CANCEL && (
                                        <Box sx={{ width: "100vw" }}>
                                            <AnalisaDataCancel
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                                {
                                    this.state.drawerMode === Global.DRAWER_MODE_DASHBOARD_PERFORMA_SALES && (
                                        <Box sx={{ width: "100vw" }}>
                                            <DashboardPerformaSales
                                                isMobile={true}
                                                onClose={this.toggleDrawer(anchor, false, true)}
                                                onSelect={this.props.onSelect}
                                                mode={this.state.drawerMode} />
                                        </Box>
                                    )
                                }

                            </DrawerMobile>
                            {/* <Box>
                                <Typography variant="h6" gutterBottom component="div" sx={{ p: 2, pb: 0 }}>
                                    Lotus Mobile
                                </Typography>
                            </Box>
                             */}
                            {/* <List sx={{width: "80vw"}}>
                                <ListItem key={"menu-1"} disablePadding>
                                    <ListItemButton>
                                    <ListItemIcon>
                                        <Hive />
                                    </ListItemIcon>
                                    <ListItemText primary={"Contacts"} />
                                    </ListItemButton>
                                </ListItem>
                                <ListItem key={"menu-2"} disablePadding>
                                    <ListItemButton>
                                    <ListItemIcon>
                                        <Hive />
                                    </ListItemIcon>
                                    <ListItemText primary={"Pengalihan"} />
                                    </ListItemButton>
                                </ListItem>
                                <ListItem key={"menu-3"} disablePadding>
                                    <ListItemButton>
                                    <ListItemIcon>
                                        <Hive />
                                    </ListItemIcon>
                                    <ListItemText primary={"Leads Report"} />
                                    </ListItemButton>
                                </ListItem>
                                <ListItem key={"menu-4"} disablePadding>
                                    <ListItemButton>
                                    <ListItemIcon>
                                        <Hive />
                                    </ListItemIcon>
                                    <ListItemText primary={"Pencarian Contact"} />
                                    </ListItemButton>
                                </ListItem>
                                <ListItem key={"menu-5"} disablePadding>
                                    <ListItemButton>
                                    <ListItemIcon>
                                        <Hive />
                                    </ListItemIcon>
                                    <ListItemText primary={"Kecepatan Respon"} />
                                    </ListItemButton>
                                </ListItem>
                                <ListItem key={"menu-6"} disablePadding>
                                    <ListItemButton>
                                    <ListItemIcon>
                                        <Hive />
                                    </ListItemIcon>
                                    <ListItemText primary={"CS"} />
                                    </ListItemButton>
                                </ListItem>
                                <ListItem key={"menu-7"} disablePadding>
                                    <ListItemButton>
                                    <ListItemIcon>
                                        <Hive />
                                    </ListItemIcon>
                                    <ListItemText primary={"Dashboard Tele"} />
                                    </ListItemButton>
                                </ListItem>
                                <ListItem key={"menu-8"} disablePadding>
                                    <ListItemButton>
                                    <ListItemIcon>
                                        <Hive />
                                    </ListItemIcon>
                                    <ListItemText primary={"Pesan Belum Direspon Sales"} />
                                    </ListItemButton>
                                </ListItem>
                                <ListItem key={"menu-9"} disablePadding>
                                    <ListItemButton>
                                    <ListItemIcon>
                                        <Hive />
                                    </ListItemIcon>
                                    <ListItemText primary={"Data Cancel"} />
                                    </ListItemButton>
                                </ListItem>
                                <ListItem key={"menu-10"} disablePadding>
                                    <ListItemButton>
                                    <ListItemIcon>
                                        <Hive />
                                    </ListItemIcon>
                                    <ListItemText primary={"Closing Rate"} />
                                    </ListItemButton>
                                </ListItem>
                                <ListItem key={"menu-11"} disablePadding>
                                    <ListItemButton>
                                    <ListItemIcon>
                                        <Hive />
                                    </ListItemIcon>
                                    <ListItemText primary={"Dashboard Solusi Data Cancel"} />
                                    </ListItemButton>
                                </ListItem>
                                <ListItem key={"menu-12"} disablePadding>
                                    <ListItemButton>
                                    <ListItemIcon>
                                        <Hive />
                                    </ListItemIcon>
                                    <ListItemText primary={"Inbox Dibaca tapi Belum Direspon"} />
                                    </ListItemButton>
                                </ListItem>
                                <ListItem key={"menu-13"} disablePadding>
                                    <ListItemButton>
                                    <ListItemIcon>
                                        <Hive />
                                    </ListItemIcon>
                                    <ListItemText primary={"Riwayat Perpindahan Contact"} />
                                    </ListItemButton>
                                </ListItem>
                                <ListItem key={"menu-14"} disablePadding>
                                    <ListItemButton>
                                    <ListItemIcon>
                                        <Hive />
                                    </ListItemIcon>
                                    <ListItemText primary={"Leads Data Pending"} />
                                    </ListItemButton>
                                </ListItem>
                                <ListItem key={"menu-15"} disablePadding>
                                    <ListItemButton>
                                    <ListItemIcon>
                                        <Hive />
                                    </ListItemIcon>
                                    <ListItemText primary={"Dashboard Performa Sales"} />
                                    </ListItemButton>
                                </ListItem>
                                <ListItem key={"menu-16"} disablePadding>
                                    <ListItemButton>
                                    <ListItemIcon>
                                        <Hive />
                                    </ListItemIcon>
                                    <ListItemText primary={"Wajib Bayar"} />
                                    </ListItemButton>
                                </ListItem>
                            </List> */}
                            {/* <MenuList sx={{width: "80vw"}}>
                                <MenuItem>
                                    <ListItemIcon>
                                        <ContentCut fontSize="small" />
                                    </ListItemIcon>
                                    <ListItemText>Cut</ListItemText>
                                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                        ⌘X
                                    </Typography>
                                </MenuItem>
                                <MenuItem>
                                    <ListItemIcon>
                                        <ContentCopy fontSize="small" />
                                    </ListItemIcon>
                                    <ListItemText>Copy</ListItemText>
                                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                        ⌘C
                                    </Typography>
                                </MenuItem>
                                <MenuItem>
                                    <ListItemIcon>
                                        <ContentPaste fontSize="small" />
                                    </ListItemIcon>
                                    <ListItemText>Paste</ListItemText>
                                    <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                        ⌘V
                                    </Typography>
                                </MenuItem>
                                <Divider />
                                <MenuItem>
                                    <ListItemIcon>
                                        <Cloud fontSize="small" />
                                    </ListItemIcon>
                                    <ListItemText>Web Clipboard</ListItemText>
                                </MenuItem>
                            </MenuList> */}
                        </SwipeableDrawer>
                    </React.Fragment>
                ))}
                {/* Drawer Menu */}



            </Container>
        );
    }
}

export default MessengerMobile;